"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationFlag = exports.NotificationFlags = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.NotificationFlags = [
    // Notification flags. Used by some handlers to add additional functionality.
    'IMPORTANT', // Used by in-app notifications to make the notification more prominent.
    'STATUS_LINKED', // Used by in-app notifications when they are sent to multiple users at once. The "read" status of those notifications will be synced.
];
exports.NotificationFlag = typebox_1.Type.Union(exports.NotificationFlags.map((flag) => typebox_1.Type.Literal(flag)));
//# sourceMappingURL=flags.js.map